import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { Observable } from 'rxjs';
import { Rol } from '../model/rol.model';
import { environment } from '@env/environment.prod';
import { User } from '../model/user.model';

@Injectable()
export class UserService extends BaseAPIClass {
  baseUrl = '';

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = this.baseUrl + '/users';
  }

  getAllRoles(): Observable<Rol[]> {
    return this.httpClient.get<Rol[]>(this.baseUrl + '/roles');
  }
  enableUser(id: number) {
    return this.httpClient.get(this.baseUrl + '/habilitar/' + id);
  }
  edit(user: any) {
    return this.httpClient.post(this.baseUrl + '/editar', user);
  }
  getAllVendedores(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.baseUrl + '/vendedores');
  }
}
